export default "<lib-monitoring-host-list></lib-monitoring-host-list>"